//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Preferences.js";
import "../no/Object.js";
import "../Preferences/Preferences.SessionPreferences.js";
let d=[[[0,"DepthSortedWireframe",1,0],[0,"WireframeContrast",1,0]],[[["update_mode_change","studio"],"RegenerateFromToleranceChange",{},2,1],[["do_software_update"],"UpdateLineFontObjects",{},1,1]],[]];
SPLM.Preferences.VisualizationLine = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.Preferences.VisualizationLine";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;